import { API } from '../../apis/limeAuthUtils/apiWrapper';
import { getAuthenticatedUser } from '../../apis/limeAuthUtils/limeToken';

const dashboardMapping = {
    // test is for local server, points to alpha dashboard
    test: { id: 'ae7e4d29-0a13-4eb3-a2d7-4c1b05c4c017', account: '493777090295' },
    alpha: { id: 'ae7e4d29-0a13-4eb3-a2d7-4c1b05c4c017', account: '493777090295' },
    qa: { id: '382b0062-6652-4cb9-afd6-b6af9c28270e', account: '026114136371' },
    beta: { id: '1c1fa0ff-3c93-4f90-974b-a6aac9023da7', account: '687257394019' },
    prod: { id: 'b015aa96-afdd-414b-9237-4690da3180c7', account: '450040307246' },
};

export default async function generateQuicksightUrl() {
    /**
     * API call to generate quicksight embed url
     * @type {string}
     */
    const apiName = 'v2/permission-validate';
    // The alpha token is replaced at build time. When running outside of
    // a webpack build (e.g. jest tests), the literal string passes through and
    // would not match any key — fall back to the alpha mapping so the code is
    // resilient in that scenario.
    const stageConfig = dashboardMapping['alpha'] || dashboardMapping.alpha;
    const dashboardId = stageConfig.id;
    const account = stageConfig.account;
    const user = await getAuthenticatedUser();
    const myInit = {
        body: {
            dashboards_arn_list: [`arn:aws:quicksight:us-west-2:${account}:dashboard/${dashboardId}`],
            initial_dashboard: dashboardId,
            session_lifetime_in_minutes: 60,
            user: user,
        },
    };
    return await API.post(apiName, '/v2/generate_quicksight_url', myInit);
}
